import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { DeprecatedCloseIcon, DeprecatedSettingsIcon } from '@mssgme/icons';

import { IconButton } from '@mssgme/ui';

import styles from './ToggleButton.scss';

ToggleButton.propTypes = {
    isPressed: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
};

export default function ToggleButton({ isPressed = false, onToggle }) {
    return (
        <IconButton
            aria-pressed={isPressed}
            className={cn(styles.root, {
                [styles.close]: isPressed,
                [styles.settings]: !isPressed,
            })}
            onClick={onToggle}
        >
            {isPressed ? <DeprecatedCloseIcon size={14} /> : <DeprecatedSettingsIcon size={14} />}
        </IconButton>
    );
}
